import React from 'react';
import { CreditCard } from 'lucide-react';

const Payments = () => (
  <div className="rounded-xl border border-gray-200 bg-white p-6 max-w-lg">
    <div className="flex items-center gap-3 mb-3">
      <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#404880]/10">
        <CreditCard size={16} className="text-[#404880]" />
      </div>
      <h3 className="text-sm font-semibold text-gray-900">Payments</h3>
    </div>
    <p className="text-sm text-gray-500">
      Payments are currently managed directly by your contracted Law Enforcement Agencies.
      For any billing inquiries, contact <a href="mailto:hello@officer.app" className="text-[#404880] hover:underline">hello@officer.app</a>.
    </p>
  </div>
);

export default Payments;
